import { render } from "./GamerDropdown.vue?vue&type=template&id=588722b1&scoped=true"
import script from "./GamerDropdown.vue?vue&type=script&lang=js"
export * from "./GamerDropdown.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./GamerDropdown.vue?vue&type=style&index=1&id=588722b1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-588722b1"

export default script